import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabResidentialCMPrograms from 'components/form-fields-clients-tabs/tab-residential-cm-programs/tab-residential-cm-programs';
class EditViewPostDischargeTabResidentialCMPrograms extends Component {
  render() {
    return (
      <div>
        <FormFieldsClientsTabsTabResidentialCMPrograms {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewPostDischargeTabResidentialCMPrograms.propTypes = {
  locked: PropTypes.bool,
}
EditViewPostDischargeTabResidentialCMPrograms = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabResidentialCMPrograms);
export default EditViewPostDischargeTabResidentialCMPrograms;